<div class="container-fluid">
    <app-pagetitle title="E-Stamp Orders" [subtitle]="'Create or upload E-Stamp orders'">
    </app-pagetitle>
    <div class="row justify-content-center">
        <div class="col-lg-10 col-md-10 col-sm-12">
            <app-loader [loading]="uploading"></app-loader>
            <div class="card shadow-sm">
                <div class="card-body">
                    <!-- Tabs Navigation -->
                    <div class="nav-tabs-custom mb-4">
                        <ul class="nav nav-tabs nav-justified" role="tablist">

                            <li class="nav-item" role="presentation">
                                <button class="nav-link" [ngClass]="{'active': activeTab === 'bulkUpload'}"
                                    (click)="switchTab('bulkUpload')" type="button" role="tab"
                                    [attr.aria-selected]="activeTab === 'bulkUpload'">
                                    <i class="fas fa-file-upload me-2"></i>Bulk Upload
                                </button>
                            </li>
                        </ul>
                    </div>



                    <!-- TAB 1: BULK UPLOAD VIA EXCEL -->
                    <div *ngIf="activeTab === 'bulkUpload'" class="tab-pane-custom">
                        <app-api-validation-message class="text-start" [error]="apiValidationError"
                            title="Unable to complete bulk upload" [dismissible]="true"
                            (dismissed)="clearApiValidationMessage()">
                        </app-api-validation-message>
                        <ng-container>
                            <div class="instructions-card mb-4">
                                <div class="d-flex align-items-center mb-3">
                                    <i class="fas fa-circle-info text-primary me-2"></i>
                                    <h6 class="fw-bold mb-0">How to Upload Orders</h6>
                                </div>
                                <ul class="instruction-steps list-unstyled mb-0">
                                    <li>
                                        <span class="step-num">1</span>
                                        <span>Download the Excel template</span>
                                    </li>
                                    <li>
                                        <span class="step-num">2</span>
                                        <span>Fill in the required columns with order data</span>
                                    </li>
                                    <li>
                                        <span class="step-num">3</span>
                                        <span>Each row should contain <strong>State</strong>,
                                            <strong>Denomination</strong> and <strong>Quantity</strong></span>
                                    </li>
                                    <li>
                                        <span class="step-num">4</span>
                                        <span>Upload the completed file</span>
                                    </li>
                                </ul>
                            </div>

                            <!-- Template Download -->
                            <div class="mb-4">
                                <button type="button" class="btn btn-outline-primary" (click)="downloadTemplate()"
                                    [disabled]="downloadingTemplate">
                                    <span *ngIf="downloadingTemplate" class="spinner-border spinner-border-sm me-2"
                                        role="status" aria-hidden="true"></span>
                                    <i class="fas fa-download me-2"></i>
                                    {{ downloadingTemplate ? 'Downloading...' : 'Download Excel Template' }}
                                </button>
                            </div>

                            <!-- File Upload -->
                            <form [formGroup]="uploadForm" (ngSubmit)="onSubmitExcelUpload()">
                                <div class="mb-3">
                                    <label class="form-label">Select Excel File <span
                                            class="text-danger">*</span></label>
                                    <div class="input-group">
                                        <input type="file" class="form-control" accept=".xlsx,.xls,.csv"
                                            (change)="onFileSelected($event)" #fileInput>
                                        <button type="button" class="btn btn-outline-secondary"
                                            *ngIf="uploadedFile || uploadErrors.length > 0" (click)="clearUploadForm()"
                                            title="Clear File">
                                            <i class="fas fa-times"></i>
                                        </button>
                                    </div>
                                    <small class="text-muted">Supported formats: Excel (.xlsx, .xls) or CSV. Max file
                                        size: 1MB</small>
                                    <div *ngIf="uploadedFile" class="mt-2">
                                        <small class="text-success">
                                            <i class="fas fa-check-circle me-1"></i>
                                            {{ uploadedFile.name }} ({{ (uploadedFile.size / 1024).toFixed(2) }} KB)
                                        </small>
                                    </div>
                                    <div *ngIf="fileSizeError" class="mt-2">
                                        <small class="text-danger">
                                            <i class="fas fa-exclamation-circle me-1"></i>
                                            {{ fileSizeError }}
                                        </small>
                                    </div>
                                </div>

                                <!-- Total Amount Display -->
                                <div *ngIf="uploadedFile && totalAmountFromExcel > 0" class="alert alert-info mt-4"
                                    role="alert">
                                    <div class="row align-items-center">
                                        <div class="col-md-6">
                                            <h6 class="mb-0">Total Amount</h6>
                                        </div>
                                        <div class="col-md-6 text-end">
                                            <h5 class="mb-0 text-primary fw-bold">₹{{ totalAmountFromExcel |
                                                number:'1.2-2'
                                                }}</h5>
                                        </div>
                                    </div>
                                </div>

                                <!-- Upload Button -->
                                <div class="d-grid">
                                    <button type="submit" class="btn btn-primary"
                                        [disabled]="uploading || !uploadedFile">
                                        <span *ngIf="uploading" class="spinner-border spinner-border-sm me-2"
                                            role="status" aria-hidden="true"></span>
                                        {{ uploading ? 'Uploading...' : 'Upload Orders' }}
                                    </button>
                                </div>
                            </form>

                            <!-- Error Report -->
                            <div *ngIf="uploadErrors.length > 0" class="alert alert-warning mt-3" role="alert">
                                <h6 class="alert-heading mb-3">
                                    <i class="fas fa-exclamation-triangle me-2"></i>
                                    Upload Errors ({{ uploadErrors.length }} row(s))
                                </h6>
                                <div class="table-responsive">
                                    <table class="table table-sm table-striped mb-0">
                                        <thead class="table-light">
                                            <tr>
                                                <th>Row #</th>
                                                <th>Error Message</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let error of uploadErrors; let i = index">
                                                <td class="text-danger fw-bold">{{ error.row || i + 1 }}</td>
                                                <td>{{ error.message }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </ng-container>

                    </div>

                </div>
            </div>
        </div>
    </div>
</div>